var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._b({attrs:{"xclass":"px-2 py-0 ma-0"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.label))])]},proxy:true}]),model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'v-checkbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }